/** A days-until pill that color-codes urgency: red ≤3 days, amber ≤7, neutral
 * beyond. Shared by the exam calendar and the class-session upcoming-exams panel. */
export function UrgencyBadge({ daysUntil }: { daysUntil: number }) {
  const label =
    daysUntil <= 0 ? 'Today' : daysUntil === 1 ? 'Tomorrow' : `In ${daysUntil} days`
  const cls =
    daysUntil <= 3
      ? 'bg-danger-tint text-danger border-danger-border'
      : daysUntil <= 7
        ? 'bg-warning-tint text-warning border-warning-border'
        : 'bg-surface-subtle text-fg-muted border-border'
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${cls}`}
    >
      {label}
    </span>
  )
}
